/**
 * Sign in with Apple — общий клиент для нативного iOS-флоу.
 *
 * `clientId` обязан совпадать сразу с тремя вещами:
 *   1. PRODUCT_BUNDLE_IDENTIFIER в `frontend/ios/App/App.xcodeproj`
 *   2. App ID, зарегистрированным в Apple Developer (с capability Sign In with Apple)
 *   3. `APPLE_BUNDLE_ID`, который бэкенд проверяет как `aud` в identity token
 *
 * Это НЕ `appId` из `capacitor.config.ts` — там лежит идентификатор
 * Android-сборки, и он намеренно другой.
 *
 * Значение вынесено в одну константу потому, что раньше было продублировано
 * в AuthModal.vue и StepPlan.vue: при смене bundle id один из двух входов
 * молча переставал работать.
 */
export const APPLE_CLIENT_ID = 'com.ptahworks.zoya'

/**
 * Показать системный диалог входа через Apple.
 * @returns {Promise<object>} response с identityToken, email, givenName, familyName
 */
export async function authorizeApple() {
  const { SignInWithApple } = await import('@capacitor-community/apple-sign-in')
  const result = await SignInWithApple.authorize({
    clientId: APPLE_CLIENT_ID,
    scopes: 'name email',
  })
  return result.response
}
